export default __webpack_public_path__ + "static/media/search-icon.72f8e8b6.svg";